<template>
  <v-card v-show="!tempIsPageLoading">
    <SearchTools
      :searchQuery.sync="searchQuery"
      @do-search="doSearch"
      @do-clear="doClear"
    >
      <template v-slot:prepend>
        <b-col :sm="3">
          <FormDatepickerBase
            :type="'text'"
            :clearable="true"
            :max="maxDate"
            :i18n="{
              label: 'FROM',
              placeholder: $t('FROM')
            }"
            :date.sync="filters.fromDate"
          ></FormDatepickerBase>
        </b-col>

        <b-col :sm="3">
          <FormDatepickerBase
            :type="'text'"
            :clearable="true"
            :max="maxDate"
            :i18n="{
              label: 'TO',
              placeholder: $t('TO')
            }"
            :date.sync="filters.toDate"
          ></FormDatepickerBase>
        </b-col>
        <b-col :lg="3" :md="12" v-if="!tempIsPageLoading && _.size(stores) > 0">
          <v-autocomplete
            v-if="_.size(stores) > 0"
            :items="stores"
            :label="$t('STORE')"
            item-text="name"
            item-value="id"
            clearable
            hide-details
            v-model="filters.storeId"
            @click:clear="clearFilter('storeId')"
          ></v-autocomplete>
        </b-col>
      </template>
    </SearchTools>
    <v-data-table
      :headers="tableHeaders"
      :items="items"
      :options.sync="options"
      :items-per-page="totalItems"
      :server-items-length="totalItems"
      sort-by="ajurNumber"
      sort-desc="true"
      :loading="isLoadingStock"
      loading-text="Loading... Please wait"
      :footer-props="{
        showFirstLastPage: true,
        itemsPerPageOptions: rowsPerPageItems,
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        itemsPerPageText: $t('ITEMS_PER_PAGE_TEXT')
      }"
      @update:options="getDataFromApi()"
      class="elevation-1"
    >
      <template v-slot:item.storeName="{ item }">
        {{ item.storeName }}
      </template>
      <template v-slot:item.regAt="{ item }">
        {{ item.regAt | formatDateTime }}
      </template>
      <template v-slot:item.ajurNumber="{ item }">
        <router-link
          v-if="checkIfUserHasPermission(['stock-actions-show'])"
          :to="{
            name: 'stock-consumptions-ajur-number',
            params: { id: item.ajurNumber }
          }"
        >
          {{ item.ajurNumber }}
        </router-link>
      </template>

      <template v-slot:no-results>
        <v-alert :value="true" color="error" icon="warning">
          Your search for "{{ searchQuery }}" found no results.
        </v-alert>
      </template>
    </v-data-table>
  </v-card>
</template>
<style scoped>
tr.previewTr th {
  font-size: 18px !important;
}
</style>
<script>
//General
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

import { mapGetters } from "vuex";
import SearchTools from "@/core/components/table/SearchTools.vue";
import FormDatepickerBase from "@/view/content/forms/components/FormDatepickerBase.vue";

//Stock Module
import { FETCH_STOCK_CONSUMPTIONS_AJUR_NUMBER } from "@/modules/stock/store/stock.module";

import { FETCH_STORES_BASIC } from "@/core/services/store/shared_store.module";

import { permissionMixin } from "@/core/mixins/permissionMixin.js";
import i18n from "@/core/plugins/vue-i18n";

import _ from "lodash";
import moment from "moment";

export default {
  name: "StockConsumptionListAjurNumberTable",
  mixins: [permissionMixin],
  props: {
    isPageLoading: {
      type: Boolean,
      default: true
    },
    firstLoader: {
      type: Boolean,
      default: true
    },
    isPreviewMode: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      items: [],
      stores: [],
      totalItems: 100,
      searchQuery: "",
      filters: {
        storeId: null,
        fromDate: null,
        toDate: null
      },
      options: {
        descending: true,
        page: 1,
        itemsPerPage: 10,
        totalItems: 100
      },
      rowsPerPageItems: [10, 20, 30, 40, 50],
      columns: {},
      headers: [
        {
          text: this.$t("AJUR_NUMBER"),
          value: "ajurNumber"
        },
        {
          text: this.$t("STORE"),
          value: "storeName",
          sortable: false
        },
        {
          text: this.$t("TOTAL"),
          value: "total"
        },
        {
          text: this.$t("FOR_DATE"),
          value: "forDate"
        },
        {
          align: "right",
          text: this.$t("ACCOUNTED"),
          value: "regAt",
          sortable: false,
          width: "10%"
        }
      ]
    };
  },
  components: {
    SearchTools,
    FormDatepickerBase
  },
  watch: {
    storesParams(value) {
      let vm = this;
      vm.filters.storeId = null;
      vm.getStores();
    }
  },
  mounted() {
    let vm = this;
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: "Stock Action Items",
        route: { name: "stock-action-items-list" }
      },
      { title: "Stock Consumptions" }
    ]);

    vm.getStores();
  },
  computed: {
    ...mapGetters([
      "getItems",
      "isLoadingStock",
      "isLoadingSharedStore",
      "currentUser"
    ]),
    tempFirstLoader: {
      get: function () {
        return this.firstLoader;
      },
      set: function (newValue) {
        this.$emit("update:firstLoader", newValue);
      }
    },
    tempIsPageLoading: {
      get: function () {
        return this.isPageLoading;
      },
      set: function (newValue) {
        this.$emit("update:isPageLoading", newValue);
      }
    },
    params() {
      return {
        ...this.options,
        query: this.searchQuery,
        fromDate: this.filters.fromDate,
        storeId: this.filters.storeId,
        toDate: this.filters.toDate
      };
    },
    storesParams() {
      let storesParams = {};
      return storesParams;
    },
    tableHeaders() {
      let vm = this;

      return vm.headers;
    },
    maxDate() {
      return moment().format("YYYY-MM-DD");
    }
  },
  methods: {
    clearFilter(key) {
      let vm = this;
      vm.$nextTick(function () {
        this.$set(vm.filters, key, null);
      });
    },
    cancelRequest() {
      //Axios cancelSource to stop current search if new value is entered
      if (this.cancelSource) {
        this.cancelSource.cancel("Start new search, stop active search");
      }
    },
    doSearch() {
      let vm = this;
      if (vm.options.page == 1) {
        vm.getDataFromApi();
      } else {
        vm.options.page = 1;
      }
    },
    doClear() {
      let vm = this;
      vm.searchQuery = "";
      vm.filters.storeId = null;
      vm.filters.fromDate = null;
      vm.filters.toDate = null;
      vm.filters.isAccounted = null;
      if (vm.options.page == 1) {
        vm.getDataFromApi();
      } else {
        vm.options.page = 1;
      }
    },
    getDataFromApi() {
      let vm = this;
      //copy current params to modify
      let params = this.params;

      params.length = params.itemsPerPage; //set how many records to fecth per page
      params.start =
        params.page == 1 ? 0 : params.itemsPerPage * (params.page - 1); //set offset
      let apiParams = vm.transformUrlParams(params);
      vm.$store
        .dispatch(FETCH_STOCK_CONSUMPTIONS_AJUR_NUMBER, apiParams)
        .then((data) => {
          vm.tempFirstLoader = false;
          vm.$nextTick(function () {
            vm.items = data.data.items;
            vm.totalItems = data.data.totalItemsCount;
            if (vm.tempIsPageLoading == true) {
              vm.tempIsPageLoading = false;
            }
          });
        })
        .catch((response) => {
          console.log(response);
          if (response.status === 404) {
            vm.$notify({
              group: "notify",
              type: "error",
              text: "Nout Found"
            });
            this.$router.push({ name: "stock-invoices-list" });
          }
        });
    },
    getStores() {
      let vm = this;
      let params = this.storesParams;
      let apiParams = vm.transformUrlParams(params);
      this.$store
        .dispatch(FETCH_STORES_BASIC, apiParams)
        .then((data) => {
          this.$set(vm, "stores", data.data);
        })
        .catch((response) => {
          console.log(response);
        });
    },
    transformUrlParams(params) {
      let apiParams =
        "?" +
        Object.keys(params)
          .map((key) => key + "=" + params[key])
          .join("&");
      return apiParams;
    }
  }
};
</script>
